import { filterDictParam } from '@/common/util.js'
import dayjs from 'dayjs';

const isUnRead = (row, msgType = 1) => {
  if (msgType === 1) {
    const d = filterDictParam(row.readStatus)
    if (d === 'UNREAD') {
      return true
    }
    return false
  } else if (msgType === 2) {
    const d = filterDictParam(row.handleStatus)
    if (d === 'TO_DO') {
      return true
    }
    return false
  } else {
    return false;
  }
}

function dur (targetTime) {
  const currentTime = dayjs()
  const diff = currentTime.diff(targetTime, 'millisecond')
  const diffSeconds = Math.abs(diff / 1000);
  const diffMinutes = Math.abs(diffSeconds / 60);
  const diffHours = Math.abs(diffMinutes / 60);
  const diffDays = Math.abs(diffHours / 24);
  
  const unit = {
    day: window.vm.$t('message.day'),
    hour: window.vm.$t('message.hour'),
    minutes: window.vm.$t('message.minutes'),
    seconds: window.vm.$t('message.seconds')
  }
  let res
  if (diffDays >= 1) {
    res = `${Math.floor(diffDays)}${unit.day}`;
  } else if (diffHours >= 1) {
    res = `${Math.floor(diffHours)}${unit.hour}`;
  } else if (diffMinutes >= 1) {
    res = `${Math.floor(diffMinutes)}${unit.minutes}`;
  } else {
    res = `${Math.floor(diffSeconds)}${unit.seconds}`;
  }

  return res
}

export {
  isUnRead,
  dur
}